import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OtherApiService } from './other.service';

@Injectable({
  providedIn: 'root',
})
export class FirebaseConfigService {
  private firebaseConfig: any;
  browserDomain : string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: OtherApiService) { }

  URLAddress(address){
    const FinalURL = this.service.URLAddress(address)
    return FinalURL; 
  }
  loadFirebaseConfig(): Promise<any> {
    
    const entity = localStorage.getItem('entityId');
    if(entity){
    return this.http.get<any>(this.URLAddress(`/view/entityWebsiteConfig?entity=${entity}`)).pipe(
      map((response) => {
        this.firebaseConfig = response
        return response;
      },err=>{
        return {}
      })
    ).toPromise();
  }else{
    return new Promise((resolve,reject)=>{
      resolve({})
    })
  }
  }

  getFirebaseConfig() {
    return this.firebaseConfig;
  }
}
